import Moment from 'moment'
export const validateMinDate = (noMinDate, minDate, isoDateFormat) => noMinDate ? null :
Moment(new Date().toISOString()).subtract(minDate, 'days').format(isoDateFormat)

export const validateMaxDate = (noMaxDate, maxDate, isoDateFormat) => noMaxDate ? null :
Moment(new Date().toISOString()).add(maxDate, 'days').format(isoDateFormat)
